module.exports = __webpack_public_path__ + "static/img/publish_banner.ec5cdf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/publish_banner.png
// module id = 1255
// module chunks = 31